module.exports = __webpack_public_path__ + "media/courses/CPD-d1e4baf5.png";